var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07087 1.43999C9.31495 1.19591 9.31495 0.800183 9.07087 0.556105C8.82679 0.312027 8.43106 0.312027 8.18699 0.556105L4.62697 4.11612L1.06696 0.556105C0.822881 0.312027 0.427153 0.312027 0.183075 0.556105C-0.0610028 0.800183 -0.0610028 1.19591 0.183075 1.43999L3.74309 5L0.183058 8.56003C-0.0610197 8.80411 -0.0610193 9.19984 0.183058 9.44391C0.427136 9.68799 0.822864 9.68799 1.06694 9.44391L4.62697 5.88388L8.187 9.44391C8.43108 9.68799 8.82681 9.68799 9.07088 9.44391C9.31496 9.19984 9.31496 8.80411 9.07088 8.56003L5.51085 5L9.07087 1.43999Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGrey);
export default __webpack_public_path__ + "static/media/x-grey.699fe3083658f00c0f35df2c15e53898.svg";
export { ForwardRef as ReactComponent };